import React from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import i18n from '@i18next/i18n';
import { MEETING_ROOM_STATE } from '../../message_const';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { tencentDocOpenUrlReload } from '@tencent/tencent_doc_open_url';
import NotPlayingContainerV1 from './index';
import stylesMobile from '../../style-mobile.less';
import stylesPC from '../../style-pc.less';

const styles = browser.isMobile ? stylesMobile : stylesPC;

const meetingRoomInfoMap = {
    [MEETING_ROOM_STATE.INIT_LOADING]: {
        loading: i18n.t('加载中......'),
        h2: i18n.t('房间建立连接中'),
        showPic: false,
        showLoading: true,
    },
    [MEETING_ROOM_STATE.PLAYER_LOADING]: {
        showPic: true,
        picClass: styles.waiting,
        h1: i18n.t('加载中......'),
        h2: i18n.t('请稍候'),
        showLoading: false,
    },
    [MEETING_ROOM_STATE.CLOSED]: {
        picClass: styles.closed,
        h1: i18n.t('远程演示已结束'),
        h2: i18n.t('请关闭页面'),
        showPic: true,
        showLoading: false,
    },
    [MEETING_ROOM_STATE.ROOM_FULL]: {
        picClass: styles.closed,
        h1: i18n.t('未成功加入演示'),
        h2: i18n.t('接入人数已超过上限'),
        showPic: true,
        showLoading: false,
    },
};

const getNotPlayingInfo = ({
    meetingRoomState, typeName, lastError, docTitle, isMaster,
}) => {
    switch (meetingRoomState) {
        case MEETING_ROOM_STATE.AUDIENCE_WAIT:
            return {
                picClass: styles.waiting,
                h1: docTitle,
                h2: isMaster ? i18n.t('加载中......') : `${i18n.t('等待演示者播放')}${typeName}`,
                showPic: true,
                showLoading: false,
            };
        case MEETING_ROOM_STATE.AUDIENCE_LOADING:
            return {
                picClass: styles.waiting,
                h1: i18n.t('远程演示暂未开始'),
                h2: `${i18n.t('开始播放后，将同步显示')}${typeName}`,
                loading: `${i18n.t('演示已开始，正在加载')}${typeName}...`,
                showPic: false,
                showLoading: true,
            };
        case MEETING_ROOM_STATE.ERROR_PAGE:
            return {
                picClass: styles.closed,
                h1: i18n.t('😰糟糕，出错了！'),
                h2: `${i18n.t('请稍后刷新页面')}(${lastError})`,
                showPic: true,
                showLoading: false,
            };
        case MEETING_ROOM_STATE.PLAY:
            return {
                picClass: styles.waiting,
                h1: i18n.t('播放启动中'),
                showPic: true,
                showLoading: false,
            };
        default:
            return meetingRoomInfoMap[meetingRoomState] || {
                picClass: styles.closed,
                h1: i18n.t('服务器开小差了'),
                h2: `${i18n.t('请刷新稍后刷新页面')}(${meetingRoomState}, ${window?.clientVars?.__retcode})`,
                showPic: true,
                showLoading: false,
            };
    }
};

interface INotPlayingContainerProps {
    meetingRoomState?: MEETING_ROOM_STATE;
    logo: string;
    typeName: string;
    lastError: string;
    docTitle: string;
    isMaster: boolean;
    loadingText?: string;
}

const NotPlayingContainer = (props: INotPlayingContainerProps) => {
    const { meetingRoomState, typeName, lastError, docTitle, isMaster, loadingText } = props;
    const { h1, h2 } = getNotPlayingInfo({
        meetingRoomState, typeName, lastError, docTitle, isMaster,
    });

    const showSnackList = [
        MEETING_ROOM_STATE.INIT_LOADING,
        MEETING_ROOM_STATE.AUDIENCE_WAIT,
    ];
    const showModalList = [
        // TODO: 新版几乎没有 ERROR 的场景了，考虑去掉这个 state
        MEETING_ROOM_STATE.ERROR_PAGE,
        MEETING_ROOM_STATE.ROOM_FULL,
        MEETING_ROOM_STATE.ROOM_CLOSE,
    ];

    const showModal = showModalList.includes(meetingRoomState as MEETING_ROOM_STATE);
    const showSnack = showSnackList.includes(meetingRoomState as MEETING_ROOM_STATE);

    // 如果不显示是直接销毁元素，snackbar 的位置会有问题：
    // 即使为 snackbar 指定了 key，实际上还是新增了一个 snack，而旧的 snack 并没有完全销毁掉
    // 最终导致，每一次显隐后， snackbar 的位置会越来越靠下
    // TODO: 只能暂时使用 visible，后续研究下有没有别的方式
    return <>
        <Modal
            visible={showModal}
            title={h1}
            content={h2}
            cancelText={null}
            okText={i18n.t('立即刷新')}
            onOk={() => tencentDocOpenUrlReload()}
            closable={false}
        />
        <Snackbar
            visible={!!loadingText || showSnack}
            type='loading'
            message={loadingText || h2}
        />
        {meetingRoomState === MEETING_ROOM_STATE.CLOSED && <NotPlayingContainerV1 {...props}/> }
    </>;


    // const showNullList = [
    //     MEETING_ROOM_STATE.PLAY,
    //     MEETING_ROOM_STATE.AUDIENCE_LOADING,
    //     MEETING_ROOM_STATE.INIT_LOADING,
    //     MEETING_ROOM_STATE.PLAYER_LOADING,
    // ];
    // return null;
};

export default NotPlayingContainer;
